import { EntityModel } from '@/interfaces'
import {
  ALL_HEADING_BLOCKS_QUERY,
  CREATE_HEADING_BLOCK_MUTATION,
  DELETE_HEADING_BLOCK_MUTATION,
  FORCE_DELETE_HEADING_BLOCK_MUTATION,
  SINGLE_HEADING_BLOCK_QUERY,
  UPDATE_HEADING_BLOCK_MUTATION,
} from './graphql'

const cmsHeadingBlockModel: EntityModel = {
  name: 'headingBlock',
  namePlural: 'headingBlocks',
  uniqueName: 'cmsHeadingBlock',
  uniqueNamePlural: 'cmsHeadingBlocks',
  path: 'cms/blocks/heading_block',
  baseUrl: '/cms/blocks/heading_blocks',
  translationPrefix: 'entities:cmsHeadingBlock.',
  getDisplayName: (values: any) => {
    return values.heading
  },
  gql: {
    getAll: ALL_HEADING_BLOCKS_QUERY,
    getSingle: SINGLE_HEADING_BLOCK_QUERY,
    create: CREATE_HEADING_BLOCK_MUTATION,
    update: UPDATE_HEADING_BLOCK_MUTATION,
    delete: DELETE_HEADING_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_HEADING_BLOCK_MUTATION,
  },
  attributes: {
    importance: {
      name: 'importance',
      label: 'entities:cmsHeadingBlock.attributes.importance.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.1.label',
          value: '1',
        },
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.2.label',
          value: '2',
        },
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.3.label',
          value: '3',
        },
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.4.label',
          value: '4',
        },
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.5.label',
          value: '5',
        },
        {
          label: 'entities:cmsHeadingBlock.attributes.importance.selectOptions.6.label',
          value: '6',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    heading: {
      name: 'heading',
      label: 'entities:cmsHeadingBlock.attributes.heading.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    addon: {
      name: 'addon',
      label: 'entities:cmsHeadingBlock.attributes.addon.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    decoration: {
      name: 'decoration',
      label: 'entities:cmsHeadingBlock.attributes.decoration.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsHeadingBlockModel
